import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
} from "@mui/material";
import { I18n } from "aws-amplify/utils";
import React, { useEffect, useState } from "react";

const AlertPopup = ({ open, onClose, alertTitle, alertMessage}) => {

  return (
    <Dialog
      open={open}
      onClose={onClose}
      sx={{
        "& .MuiDialog-paper": { width: "90%", maxWidth: "none", borderRadius:"1rem"},
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <DialogTitle color={alertTitle=="Success"?"green":"error"} align="center">
        {alertTitle}
      </DialogTitle>
      <DialogContent sx={{
         padding: "0px 20px 0px"
      }}>{alertMessage}</DialogContent>
      
        <DialogActions>
        {alertTitle!=="Success" && (
        <Button onClick={onClose} color="primary">
          {I18n.get("Close")}
        </Button>
        )
      }
      </DialogActions>
      
    </Dialog>
  );
};
export default AlertPopup;
